import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../services/api"; 
import { requiredFieldClass } from "../lib/requiredFieldClass";
import { applicationSuccessMessage } from "../lib/applicationSuccessMessage";
import "./Form.css";

function formatYmd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

const JisaKinmuForm = ({ onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [formData, setFormData] = useState({
    targetDate: formatYmd(new Date()),
    startTime: "10:00",
    endTime: "19:00",
    breakTime: "1",
    reason: "",
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const passedDate = params.get("date");
    if (passedDate) {
      setFormData(prev => ({ ...prev, targetDate: passedDate }));
    }
  }, [location]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.reason.trim()) {
      alert("指示内容・理由を入力してください。");
      return;
    }
    if (!window.confirm("時差勤務申請を送信してもよろしいですか？")) return;

    try {
      await api.post("/api/forms/submit_jisa_kinmu/", formData);
      alert(applicationSuccessMessage("時差勤務申請が正常に提出されました。", [
        "スケジュールの画面から時差勤務のシフトを選択できます。",
      ]));
      navigate("../schedule");
    } catch (error) {
      alert("送信に失敗しました。もう一度お試しください。");
    }
  };

  return (
    <div className="container form-container">
      <h3>時差勤務申請</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">適用日</label>
          <input
            type="date"
            name="targetDate"
            className="form-control"
            value={formData.targetDate}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-section mb-3">
          <div className="form-section-title">勤務予定時間</div>
          <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
            <input
              type="time"
              name="startTime"
              className="form-control"
              value={formData.startTime}
              onChange={handleInputChange}
              required
            />
            <span>〜</span>
            <input
              type="time"
              name="endTime"
              className="form-control"
              value={formData.endTime}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label className="form-label">休憩時間</label>
            <select
              name="breakTime"
              className="form-select"
              value={formData.breakTime}
              onChange={handleInputChange}
            >
              <option value="0">0時間</option>
              <option value="0.25">0.25時間（15分）</option>
              <option value="0.5">0.5時間（30分）</option>
              <option value="0.75">0.75時間（45分）</option>
              <option value="1">1.0時間（60分）</option>
              <option value="1.25">1.25時間（75分）</option>
              <option value="1.5">1.5時間（90分）</option>
            </select>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">上司の指示・理由</label>
          <textarea
            name="reason"
            className={requiredFieldClass(formData.reason)}
            rows="3"
            value={formData.reason}
            onChange={handleInputChange}
            placeholder="例：○○部長の指示により出勤時間を変更"
            required
          ></textarea>
        </div>

        <div className="button-group">
          <button type="submit" className="btn-submit">申請</button>
          <button type="button" className="btn-back" onClick={onBack ? onBack : () => navigate("/applications")}>戻る</button>
        </div>
      </form>
    </div>
  );
};

export default JisaKinmuForm;